import { HttpErrorResponse } from '@angular/common/http';
import { NgZone } from '@angular/core';
import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { eFeatures, eMailingCategory, eUserRole } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { EditMailingRecSearchRes, Mailing, MailingRecipSearchReq, MailingRecSummaryRes } from '../../../models/mailing.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { SearchQueryResponse } from '../../../models/search.model';
import { EmailBlastService } from '../../../services/email-blast.service';
import { GlobalService } from '../../../services/global.service';
import { ContactCommonSearchService } from '../../../services/shared/contact-common-search.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';
declare var $: any;

@Component({
    selector: 'app-mailing-recipient-search',
    templateUrl: './mailing-recipient-search.component.html',
    styleUrls: ['./mailing-recipient-search.component.css']
})
/** mailing-recipient-serach component*/
export class MailingRecipientSearchComponent {
    encryptedUser: string = "";
    user: CLPUser;
    userResponse: UserResponse;
    roleFeaturePermissions: RoleFeaturePermissions;
    dateFormat: string = "";
    showSpinner: boolean = false;
    mailingId: number = 0;
    type: number = 0;
    mailingResponseSearch: EditMailingRecSearchRes;
    showSaveSearchForm: boolean = false;
    currentRecipientSummary: MailingRecSummaryRes;
    showSaveSearch: boolean = false;
    totalContactCount: number = 0;
    customSearch: SearchQueryResponse;
    contactListSource = new MatTableDataSource<any>([]);
    contactListDisplayColumns: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    public contactsData: any[];
    ShowAddress: boolean = false;
    sendMailInfo: any = { isShow: false, contactId: 0 };
    clpUserID: any;
    marketingType: string = 'email-blast';
    reqRecipMailing: MailingRecipSearchReq;
    columns = [
        { field: '$', title: '', width: '40' },
        { field: '$$', title: '  ', width: '40' },
        { field: 'name', title: 'Name', width: '184' },
        { field: 'email', title: 'Email', width: '70' },
        { field: 'text', title: 'Text', width: '70' },
        { field: 'companyName', title: 'Company', width: '159' },
        { field: 'phone', title: 'Phone', width: '142' },
        { field: 'userName', title: 'User', width: '142' },
        { field: 'dtModifiedDisplay', title: 'Modified', width: '104' },
        { field: 'dtCreatedDisplay', title: 'Created', width: '112' },
    ];
    selectedId: number = 0;
    selectedContactData: any;
    selectedCallType: string;
    isShowNewCallModal: boolean;
    mailingData: Mailing;
    emailType: number = 2;
    strcontactSearchDisplay: string = "";
    private destroy$ = new Subject<void>();

    /** mailing-recipient-serach ctor */
    constructor(
        private _globalService: GlobalService,
        private _router: Router,
        private route: ActivatedRoute,
        public _localService: LocalService,
        private _utilityService: UtilityService,
        private _emailBlastService: EmailBlastService,
        private _contactCommonSearchService: ContactCommonSearchService,
        private _ngZone: NgZone
    ) {
        this.subscribeToEvents();
    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
                            this.mailingId = params.mid;
                            this.type = params.type;
                            this.loadMailingData();
                            this.setUp();
                        });
                    }
                    else
                        this._router.navigate(['/login']);
                })
            }
            else
                this._router.navigate(['/login']);
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.user = this.userResponse.user;
                            this.dateFormat = this.user?.dateFormat;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mailing-recipent-search.authenticateR", err.message, null, 'Features ' + eFeatures.None)
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async setUp() {
        await this._emailBlastService.mailingRecipientSearch_Setup(this.encryptedUser, Number(this.mailingId), this.user?.cLPCompanyID, this.user?.cLPUserID)
            .then(async (result: EditMailingRecSearchRes) => {
                if (result) {
                    this.mailingResponseSearch = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.mailingResponseSearch)) {
                        this.currentRecipientSummary = UtilityService.clone(this.mailingResponseSearch.currentRecipientSummary);
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mailing-recipent-search.authenticateR", err.message, null, 'Features ' + eFeatures.None)
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadMailingData() {
        await this._emailBlastService.mailingLoadByMailingId(this.encryptedUser, this.mailingId)
            .then(async (result: Mailing) => {
                if (!isNullOrUndefined(result)) {
                    this.mailingData = UtilityService.clone(result);
                    switch (this.mailingData?.category) {
                        case eMailingCategory.Email:
                            this.marketingType = "email-blast";

                            break;
                        case eMailingCategory.Mail: this.marketingType = "email-blast";
                            break;
                        case eMailingCategory.TxtMsg:
                            this.marketingType = "text-campaign";
                            break;
                        default:
                            break;
                    }
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("view-direct-mail.loadMailingData", err.message, null, 'mailingId ' + this.mailingId)
                this._utilityService.handleErrorResponse(err);
            });
    }



    setTotalContactCount(event: number) {
        this.totalContactCount = event;
    }

    private subscribeToEvents(): void {
        this._contactCommonSearchService.contactListChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.contactsData = data;
                this.setContactListGrid(this.contactsData);
            })
        });

        this._contactCommonSearchService.contactCountChanged.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => this.totalContactCount = data)
        });

        this._contactCommonSearchService.contactShowAddress.pipe(takeUntil(this.destroy$)).subscribe((data) => {
            this._ngZone.run(() => {
                this.ShowAddress = data;
                if (this.ShowAddress) {
                    if (!this.columns.some(obj => obj.field == "address")) {
                        this.columns.splice(6, 0, { field: 'address', title: 'Address', width: '70' });
                        this.contactListDisplayColumns = this.columns.map(c => c.field);
                    }
                }
                else {
                    this.columns = this.columns.filter(col => col.field !== 'address');
                    this.contactListDisplayColumns = this.contactListDisplayColumns.filter(col => col !== 'address');
                }
            })
        });
    }

    setContactListGrid(list) {
        this.contactListDisplayColumns = this.columns.map(c => c.field);
        this.contactListSource.data = list;
        this.addTimeout(() => {
            this.contactListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('contact_map_grid') ? this._localService.getPageSize('contact_map_grid') : 50;
            }
            if (this.sort) {
                this.contactListSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('contact_map_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)

    }

    hideTextMail() {
        this.selectedId = 0;
        $('#sendTextModal').modal('hide');
    }

    onPageChange(event: any) {
        localStorage.setItem('pageSize', event.pageSize);
    }

    showTextMail(contactId) {
        this.selectedId = contactId;
        $('#sendTextModal').modal('show');
    }

    gotoLink(event, columnName, dataItem) {
        if (columnName == "email") {
            $('#sendEmail').modal('show');
            this.sendMailInfo.isShow = true;
            this.sendMailInfo.contactId = dataItem?.contactID;
        }
        else if (columnName == "userName") {
            let url = '/edit-profile/' + dataItem?.clpUserId;
            return url;
        }
        else {
            this.clpUserID = dataItem.clpUserId
            if (this.user.timeZoneWinId != 0) {
                let url = '/contact/' + dataItem.contactID;
                return url;
            }
            else {
                $('#timezoneModal').modal('show');
            }
        }
    }

    onCompanySelect(companyId) {
        return `company-create?cid=${companyId}`;
    }

    hideSendMail() {
        $('#sendEmail').modal('hide');
        this.sendMailInfo.isShow = false;
        this.sendMailInfo.contactId = 0;
    }

    async hideTextCallModal() {
        $('#newCallCreateModal').modal('hide');
        this.isShowNewCallModal = false;
    }

    async openModalNewCall(contact, callType: string) {
        this.selectedContactData = contact
        this.selectedCallType = callType;
        this.isShowNewCallModal = true;
    }

    showColumn(columnDef): boolean {
        return columnDef ? (columnDef == 'email') || (columnDef == 'phone') ? false : true : true;
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    isRunSearch(event) {
        this.showSaveSearch = true;
        this.showSaveSearchForm = false;
        let cSearch = JSON.parse(localStorage.getItem('mailing-recipient-search'));
        if (cSearch != undefined) {
            this.customSearch = cSearch;
        }
    }

    async updateQuery() {
        this.copyObjectmailingRecipent();
        await this._emailBlastService.mailingRecipientSearch_Update(this.encryptedUser, this.reqRecipMailing)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    let response = UtilityService.clone(result);
                    if (response.messageBool) {
                        this.editMailing();
                    }
                }

            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("view-direct-mail.loadMailingData", err.message, null, 'mailingId ' + this.mailingId)
                this._utilityService.handleErrorResponse(err);
            });
    }

    copyObjectmailingRecipent() {
        this.reqRecipMailing = <MailingRecipSearchReq>{};
        this.reqRecipMailing.mailingID = this.mailingId;
        this.reqRecipMailing.clpUserID = this.user?.cLPUserID;
        this.reqRecipMailing.clpCompanyID = this.user?.cLPCompanyID;
        this.reqRecipMailing.customSearchID = this.mailingData.customSearchID;
        this.reqRecipMailing.searchQueryReq = this.customSearch;
        this.reqRecipMailing.havingScore = "";
        this.reqRecipMailing.isArchive = false;
        this.reqRecipMailing.useExtendedSearch = false;
    }


    editMailing() {
        this._router.navigateByUrl(`marketing/mailing?mid=${this.mailingId}`);
    }

    setContactSearchDisplay(event) {
        this.strcontactSearchDisplay = event;
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
